module.exports = __webpack_public_path__ + "img/welcome1.000181a0.jpg";